// extracted by mini-css-extract-plugin
export var fullHeightState = "_1x-7";
export var headerCell = "_1x-1";
export var loadingStateCell = "_1x-4";
export var rowWrapper = "_1x-3";
export var standaloneTable = "_1x-8";
export var standaloneTableWithBodyFill = "_1x-9";
export var stateCell = "_1x-5";
export var table = "_1x-0";
export var tableBodyFiller = "_1x-6";
export var white = "_1x-2";